import { Component } from "react";
import { Link, withRouter } from 'react-router-dom';
import AppContext from "../../contexts/AppContext";

import { ReactComponent as Mountain } from "../assets/icons/mountain-ic.svg";
import { ReactComponent as Windows } from "../assets/icons/windows-ic.svg";

import "./style.scss";

let lastScrollY = 0;

class FilterMenu extends Component {

    static contextType = AppContext;

    state = {
        show: false,
        hidden: false
    }

    toggleFilter = () => {
        this.setState({ show: !this.state.show });
    }

    endToggle = (e) => {
        if (!this.state.show) this.container.scrollTo(0, 0);
    }

    scrollHandler = (e) => {
        var maxScrollY = window.scrollMaxY || (document.documentElement.scrollHeight - document.documentElement.clientHeight)
        let scrollY = Math.min(Math.max(window.scrollY, 0), maxScrollY);
        if (this.ddFilter.getBoundingClientRect().width) {            
            if (scrollY > lastScrollY && !this.state.hidden && !this.state.show) this.setState({ hidden: true });
            else if (scrollY < lastScrollY && this.state.hidden) this.setState({ hidden: false });
        }
        lastScrollY = scrollY;
    }

    componentDidMount() {
        this.filterMenu.addEventListener("transitionend", this.endToggle);
        window.addEventListener('scroll', this.scrollHandler);
        window.addEventListener("resize", this.updateSize);
    }

    componentWillUnmount() {
        this.filterMenu.removeEventListener("transitionend", this.endToggle);
        window.removeEventListener('scroll', this.scrollHandler);
        window.removeEventListener("resize", this.updateSize);
    }

    componentDidUpdate = () => {
        let catUrl = this.props.match.params.title;
        catUrl = catUrl ? catUrl : "all";        
        if (catUrl !== this.catUrl) {
            this.catUrl = catUrl;
            if (this.state.show) this.setState({ show: false });
        }
    }

    updateSize = () => {
        let mobile = window.innerWidth < 600 ? true : false;
        if (!mobile && this.state.hidden) this.setState({ hidden: false, show: false });
    }

    render() {
        let { show, hidden } = this.state;

        return (
            <nav className={`filter-menu ${show ? "show" : ""} ${!show && hidden ? "hidden" : ""}`} ref={el => (this.filterMenu = el)}>
                <div className="dd-filter-menu" ref={el => (this.ddFilter = el)} onClick={this.toggleFilter}><span>{ (this.props.selectedID && this.props.selectedID!==1) ? this.context.allCategories[this.props.selectedID].title.toUpperCase() : "FILTER BY CATEGORY"}</span><span className="arrow"></span></div>
                <div className="container-menu" ref={el => (this.container = el)}>
                    <div className="content">
                        <div className="cat-title"><Mountain /><span>CUSTOM</span></div>
                        <Link className="uh" to="./design-your-own-card">Design Your Own Card</Link>

                        <div className="cat-title"><Windows /><span>CATEGORIES</span></div>

                        {this.props.categories ?
                            this.props.categories.map((category, i) => {
                                let active = category.url === this.catUrl;
                                return <Link key={`cat-${i}`} className={`uh ${active ? "active" : ""}`} to={category.url[0]==="/" ? category.url : `/category/${category.url}`}>{category.title}</Link>
                            }) : null
                        }
                    </div>
                </div>
            </nav>
        )
    }
}

export default withRouter(FilterMenu);